import React from "react";
import Header from "../../components/Header/Header";
import "./Privacy.css";

function Privacy() {
  return (
    <main className="Privacy">
      <Header
        title="Privacy Policy"
        subtitle="Learn how we collect, use, and protect your personal information. We are committed to keeping your data safe and ensuring transparency in how we handle your privacy."
      />
      <h3>Introduction</h3>
      <p>
        We value your privacy and are dedicated to safeguarding your personal
        data. This Privacy Policy explains what information we collect, how we
        use it, and the choices you have regarding your data. By using our
        services, you agree to the practices described in this policy.
      </p>
      <h3>Information We Collect</h3>
      <ul>
        <li>
          <p>
            <span className="bold">Personal Information:</span> Name, email
            address, billing details, and account preferences.
          </p>
        </li>
        <li>
          <p>
            <span className="bold">Usage Data:</span> Pages visited, products
            viewed, time spent on our site, and actions taken.
          </p>
        </li>
        <li>
          <p>
            <span className="bold">Device Information:</span> Browser type,
            operating system, IP address, and cookies.
          </p>
        </li>
      </ul>
      <h3>How We Use Your Information</h3>
      <p>We use your information to:</p>
      <ul>
        <li>
          <p>
            <span className="bold">Personal Information:</span> Name, email
            address, billing details, and account preferences.
          </p>
        </li>
        <li>
          <p>Provide and improve our services</p>
        </li>
        <li>
          <p>Personalize your experience</p>
        </li>
        <li>
          <p>Process transactions securely</p>
        </li>
        <li>
          <p>Communicate important updates or promotions</p>
        </li>
        <li>
          <p>Protect against fraud and unauthorized activity</p>
        </li>
      </ul>
      <h3>Data Sharing and Disclosure</h3>
      <p>
        We never sell your personal information. We may share data only with:
      </p>
      <ul>
        <li>
          <p>
            Trusted third-party service providers (payment gateways, analytics
            tools, hosting services)
          </p>
        </li>
        <li>
          <p>Legal authorities when required by law</p>
        </li>
      </ul>
      <h3>Data Security</h3>
      <p>
        We implement industry-standard security measures to protect your data
        from unauthorized access, loss, or disclosure.
      </p>
      <h3>Your Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>
          <p>Access, update, or delete your personal data</p>
        </li>
        <li>
          <p>Opt out of marketing communications</p>
        </li>
        <li>
          <p>Request information on how your data is being used</p>
        </li>
      </ul>
      <h3>Cookies</h3>
      <p>
        We use cookies to enhance your experience and provide personalized
        content. You can manage your cookie preferences through your browser
        settings.
      </p>
      <h3>Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with the updated date.
      </p>
    </main>
  );
}

export default Privacy;
